export default () => {
    const searchFormInput = document.querySelector('.search input');
    const deleteSearchButton = document.querySelector('.search .delete-search-button');
    if (searchFormInput && deleteSearchButton) {
        searchFormInput.addEventListener('keyup', () => {
            if (searchFormInput.value != '') {
                deleteSearchButton.style.display = 'block';
            }
            else {
                deleteSearchButton.style.display = 'none';
            }
        });
        deleteSearchButton.addEventListener('click', (e) => {
            e.preventDefault();
            searchFormInput.value = '';
            deleteSearchButton.style.display = 'none';
        });
    }
};
